import { Factory } from 'miragejs';

const ID_SCAN_FIELDS = [
  {
    id: 'first_name',
    displayName: 'First name',
  },
  {
    id: 'last_name',
    displayName: 'Last name',
  },
  {
    id: 'type',
    displayName: 'ID type',
  },
  {
    id: 'number',
    displayName: 'ID number',
  },
  {
    id: 'expiration',
    displayName: 'Expiration date',
  },
  {
    id: 'dob',
    displayName: 'Date of birth',
  },
  {
    id: 'yob',
    displayName: 'Year of birth',
  },
  {
    id: 'pob',
    displayName: 'Place of birth',
  },
  {
    id: 'issue_date',
    displayName: 'Issue date',
  },
  {
    id: 'gender',
    displayName: 'Gender',
  },
  {
    id: 'citizenship',
    displayName: 'Citizenship',
  },
  {
    id: 'nationality',
    displayName: 'Nationality',
  },
  {
    id: 'full_address',
    displayName: 'Full address',
  },
  {
    id: 'city',
    displayName: 'City',
  },
  {
    id: 'state',
    displayName: 'State',
  },
  {
    id: 'street',
    displayName: 'Street address',
  },
  {
    id: 'unit',
    displayName: 'Apt/Unit',
  },
  {
    id: 'country',
    displayName: 'Country',
  },
  {
    id: 'zip',
    displayName: 'Zip code',
  },
];

export default Factory.extend({
  id(i) {
    return ID_SCAN_FIELDS[i % ID_SCAN_FIELDS.length].id;
  },

  displayName(i) {
    return ID_SCAN_FIELDS[i % ID_SCAN_FIELDS.length].displayName;
  },
});

export { ID_SCAN_FIELDS };
